import { useState, useEffect, useRef } from "react";
import { useDetails } from "../../../../../context/details"
import { Data as ParticipationInterface } from "../../../../modules/Participation/ParticipationRow/ParticipationRow.interface";
import { AppNames, fetchDoveCommunitiesParticipations, fetchDoveHubParticipations } from "../Participations/utils";

export const useParticipationsDetail = () => {
  const { activeTab, detailsDispatch, participationsDetails } = useDetails();
  const [data, setData] = useState<{
    data: {
      results: ParticipationInterface[] | [],
      count: number,
    }
    isLoading: boolean,
    refetch: boolean,
    page: number
  }>({
    data: {
      results: [],
      count: 0
    },
    isLoading: true,
    refetch: true,
    page: 1
  });

  const goBack = () => {
    detailsDispatch({
      type: "setParticipationsDetailsUrl",
      data: null
    })
    setData({
      data: {
        results: [],
        count: 0
      },
      isLoading: true,
      refetch: true,
      page: 1
    })
    detailsDispatch({
      type: "setActiveTab",
      data: {
        id: 1,
        name: ""
      }
    })
  }

  const dataLoaded = useRef(false);
  const handleChangePage = () => {
    if (data.data.results.length > 0) {
      if (data.data.results.length < data.data.count) {
        dataLoaded.current = false;
        setData({
          ...data,
          page: data.page + 1
        })
      }
    }
  }


  useEffect(() => {
    if (participationsDetails && !dataLoaded.current) {
      dataLoaded.current = true;
      const { appType, url } = participationsDetails || {};
      const actionUrl = {
        ...url,
        url: url.url + `?page=${data.page}`
      }
      if (appType === AppNames.dovehub) {
        fetchDoveHubParticipations(actionUrl).then((res) => {
          setData({
            data: {
              count: res.count,
              results: [...data.data.results, ...res.results]
            },
            isLoading: false,
            refetch: false,
            page: data.page
          })
        })
      }
      if (appType === AppNames.community) {
        fetchDoveCommunitiesParticipations(actionUrl).then((res) => {
          setData({
            data: {
              count: res.count,
              results: [...data.data.results, ...res.results]
            },
            isLoading: false,
            refetch: false,
            page: data.page
          })
        })
      }
    }
  }, [participationsDetails, data.page])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return {
    activeTab,
    goBack,
    data,
    handleChangePage
  }
}
